var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSucuri(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#26BA9D;}\r\n\t.st1{fill:#27BA9E;}\r\n\t.st2{fill:#25998C;}\r\n\t.st3{fill:#269187;}\r\n\t.st4{fill:#249187;}\r\n\t.st5{fill:#28A190;}\r\n\t.st6{fill:#26998C;}\r\n\t.st7{fill:#268983;}\r\n\t.st8{fill:#258A84;}\r\n\t.st9{fill:#27B098;}\r\n\t.st10{fill:#27A291;}\r\n\t.st11{fill:#258380;}\r\n\t.st12{fill:#27A894;}\r\n\t.st13{fill:#277C7C;}\r\n\t.st14{fill:#2C7D7D;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.3,55.9c1.7-1,3.4-2.1,5.3-3.3c-2.5-1.5-5-2.9-7.3-4.3c-0.4-0.2-1-0.3-1-0.8c0-0.4,0.6-0.5,1-0.7 c5.2-3,10.3-6,15.5-9c0.4-0.2,0.7-0.4,1.1-0.6c0.3,0.2,0.2,0.4,0.2,0.7c0,6.3,0,12.7,0,19c0,0.6,0.1,1.1-0.6,1.4 c-3.1,1.7-6.2,3.5-9.3,5.3c-0.7-0.1-0.7-0.7-1-1.1C75.1,60.2,73.8,58,72.3,55.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.7,25.7c3.2-1.9,6.4-3.9,9.6-5.8c0.5-0.3,0.9-0.2,1.4,0.1c5.4,3.2,10.9,6.3,16.3,9.4c0.9,0.5,0.8,0.8,0,1.2 c-2.5,1.4-5,2.8-7.4,4.3c-0.6,0.3-0.9,0.3-1.5,0c-2.3-1.4-4.7-2.7-6.9-4.2c-0.9-0.6-1.6-0.6-2.5,0c-1.3,0.8-2.5,1.9-4.1,2.1 c-1.4-1.6-2.1-3.6-3.2-5.3C56,26.9,55.8,25.9,54.7,25.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M55.7,45.9c-0.7,0.7-1.5,1.2-2.5,1.4c-1.4-3-3.2-5.7-4.7-8.6c-1.3-2.3-2.9-4.5-3.8-7c0.9-0.7,1.8-1.2,2.8-1.7 c-0.1,0.6,0.2,1.1,0.5,1.6c1.9,3.2,3.8,6.3,5.5,9.6C54.4,42.7,55.8,43.9,55.7,45.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M66.1,70c-0.7,0.7-1.4,0.7-2.2,0.1c-0.8-0.6-1.7-1.1-2.6-1.6c0.5-0.7,0.1-1.4-0.2-2c-0.7-1.3-1.5-2.6-2.3-3.9 c-1.3-2.3-2.7-4.7-4-7.1c0.7-0.7,1.3-0.8,2.2-0.2c0.7,0.6,1.6,1,2.4,1.5c0,0.5,0.2,0.9,0.4,1.3c1.1,2,2.3,3.9,3.3,5.9 C64.1,66.1,65.6,67.8,66.1,70z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M44.6,31.7c0.9,2.5,2.6,4.7,3.8,7c1.5,2.9,3.4,5.6,4.7,8.6c-0.2,0.7-1,0.4-1.3,0.9c-1,0.4-1.5-0.2-2-0.9 c-1.6-2.8-3.1-5.6-4.8-8.4c-0.6-1-0.9-2.3-2.1-2.9c0-0.6,0-1.2-0.1-1.8C42.7,32.8,43.4,32,44.6,31.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M55.7,45.9c0.1-1.9-1.3-3.2-2.2-4.8c-1.7-3.2-3.7-6.4-5.5-9.6c-0.3-0.5-0.6-1-0.5-1.6c0.3-0.3,0.6-0.5,1-0.6 c0.7,0.3,0.9,0.9,1.3,1.4c1.2,2,2.2,4.1,3.6,5.9c-0.3,0.3-0.6,0.5-1.1,0.9c3,1.7,5.9,3.4,8.9,5.2C59.2,44,57.6,45.2,55.7,45.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M66.1,70c-0.5-2.2-2.1-3.9-3.1-5.9c-1-2-2.2-3.9-3.3-5.9c-0.2-0.4-0.5-0.8-0.4-1.3c1.8,1.1,3.6,2.2,5.4,3.2 c0.9,1.6,1.6,3.3,2.7,4.8c0.7,1,1,2.5,2.4,2.9C68.6,68.6,67.4,69.3,66.1,70z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M54.8,55.6c1.3,2.4,2.7,4.7,4,7.1c0.7,1.3,1.5,2.6,2.3,3.9c0.3,0.6,0.7,1.2,0.2,2c-1.4-0.7-2.7-1.4-3.9-2.3 c-0.6-2-1.9-3.8-2.8-5.6c-0.6-1.2-1.8-2.2-1.7-3.8C53.4,56.3,54.1,55.9,54.8,55.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M43,36c1.2,0.6,1.5,1.9,2.1,2.9c1.7,2.8,3.2,5.6,4.8,8.4c0.4,0.8,1,1.4,2,0.9c-0.9,0.7-1.9,1.2-2.9,1.7 c-0.3-0.2-0.7-0.3-0.9-0.7c-0.7-1.4-1.4-2.8-2.3-4.1c-0.9-1.4-1.4-3.1-2.8-4.2C43,39.2,43,37.6,43,36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M54.7,25.7c1.1,0.2,1.3,1.1,1.7,1.8c1.1,1.7,1.8,3.7,3.2,5.3c-0.8,1.1-2.1,1.4-3.1,2.1 c-1.1-2.8-2.6-5.4-4.2-7.8C53,26.6,53.8,26.1,54.7,25.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M72.3,55.9c1.5,2.1,2.8,4.3,3.9,6.6c0.2,0.4,0.3,1,1,1.1c-0.9,0.7-1.9,1.3-3,1.7c-1.6-2.6-3-5.2-4.3-7.9 C70.6,56.8,71.4,56.3,72.3,55.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M69.8,67.9c-1.4-0.4-1.7-1.9-2.4-2.9c-1-1.5-1.8-3.2-2.7-4.8c0.9-0.1,1.4-0.9,2.3-1.1 c0.9-0.1,1.2,0.6,1.6,1.3c1.2,2,2.4,4.1,3.5,6.1C71.4,67.1,70.6,67.5,69.8,67.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M52.8,56.8c-0.1,1.5,1.1,2.6,1.7,3.8c1,1.9,2.2,3.6,2.8,5.6c-2-1-4-2.2-5.9-3.4c0.1-1-0.2-1.8-0.8-2.6 c-0.4-0.5-0.7-1.1-0.7-1.8C50.9,57.8,51.8,57.2,52.8,56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M43,40.8c1.3,1.1,1.9,2.8,2.8,4.2c0.8,1.3,1.6,2.7,2.3,4.1c0.2,0.4,0.5,0.5,0.9,0.7c-0.8,0.6-1.6,1.1-2.5,1.4 c-0.6-0.3-0.6-0.9-1-1.3c-0.9-1.1-1-2.8-2.4-3.5C43,44.5,43,42.6,43,40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M52.3,27.2c1.7,2.5,3.2,5,4.2,7.8c-0.7,0.4-1.3,0.8-2,1.2c-0.4-1.3-1.1-2.4-1.8-3.5c-0.9-1.4-1.3-3.1-2.8-4.1 C50.6,28,51.4,27.5,52.3,27.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M72.1,66.5c-1.2-2-2.4-4.1-3.5-6.1c-0.4-0.7-0.7-1.4-1.6-1.3c0.9-0.7,1.8-1.2,2.8-1.7 c1.3,2.7,2.8,5.4,4.3,7.9C73.5,65.9,72.9,66.3,72.1,66.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M49.9,28.6c1.5,1,1.9,2.7,2.8,4.1c0.7,1.1,1.4,2.2,1.8,3.5c-0.4,0.2-0.8,0.4-1.2,0.6c-1.4-1.9-2.4-4-3.6-5.9 c-0.3-0.6-0.6-1.2-1.3-1.4C48.9,29,49.4,28.7,49.9,28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M43,46.4c1.4,0.7,1.5,2.4,2.4,3.5c0.4,0.4,0.4,1.1,1,1.3c-1.1,0.6-2.1,1.3-3.4,2C43,50.8,43,48.6,43,46.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M50,58.5c0,0.7,0.3,1.2,0.7,1.8c0.5,0.8,0.9,1.6,0.8,2.6c-1.4-0.8-2.9-1.6-4.5-2.5C48,59.5,49,59,50,58.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucuri);
export default __webpack_public_path__ + "static/media/Sucuri.21256c74310cde6e99413f4d066d50c8.svg";
export { ForwardRef as ReactComponent };